var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.list,"item-value":"name"},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_vm._v("\n        "+_vm._s(_vm._f("translation")(item.title))+"\n    ")]}},{key:"selection",fn:function(ref){
var item = ref.item;
return [_vm._v("\n        "+_vm._s(_vm._f("translation")(item.title))+"\n    ")]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})}
var staticRenderFns = []

export { render, staticRenderFns }